<template>
<div class="row">
    <div
        class="col-xs-12 col-md-6"
        v-for="option in question.options"
    >
        <label
            class="w-100 d-flex justify-content-between py-2"
            :class="getEffectClass(option)"
            @click="updateCheckbox(option)"
        >
            <span>{{ option.label }}</span>
            <svg-image
                svg_name="check"
                :color="getCheckColor(option)"
            />
        </label>
    </div>

    <div
        class="col-xs-12 col-md-6"
        v-if="has_other_option"
    >
        <label
            class="w-100 d-flex justify-content-between py-2"
            :class="getEffectClass(other_option)"
            @click="updateCheckbox(other_option)"
        >
            <span>{{ other_option.label }}</span>
            <svg-image
                svg_name="check"
                :color="getCheckColor(other_option)"
            />
        </label>
        <form-question-free-text
            v-if="isSelected(other_option)"
            :id="id_other_computed"
            :question="question"
            :request_form="request_form"
            required
            placeholder="Please type your other answer"
            @update-value="updateValue"
        />
    </div>
</div>
</template>

<script>
import FormQuestionFreeText from "./FormQuestionFreeText.vue";

export default {
    name: "FormQuestionCheckBox",
    comments: {
        FormQuestionFreeText,
    },
    props: {
        question: Object,
        settings: Object,
        request_form: Object,
        is_radio: Boolean,
    },
    data() {
        return {
            selected: [],
            other_option: {
                label: 'Other',
            },
        }
    },
    computed: {
        id_computed() {
            return this.question.local_id + '.checkbox';
        },
        id_other_computed() {
            return this.id_computed + '.other';
        },
        has_other_option() {
            return this.question.type.includes('_other');
        },
    },
    mounted() {
        if (this.request_form.hasOwnProperty(this.id_computed) && this?.request_form[this.id_computed]) {
            this.selected = this.request_form[this.id_computed];
        }
    },
    methods: {
        updateCheckbox(option) {
            const new_id = this.getOptionId(option);
            if (this.is_radio) {
                this.handleRadioChange(new_id);
            } else {
                this.handleCheckBoxChange(new_id);
            }

            this.updateOther();

            const value = this.selected.length > 0 ? this.selected : null;

            this.updateValue(this.id_computed, value);
        },

        updateOther() {
            if (!this.isSelected(this.other_option)) {
                this.updateValue(this.id_other_computed, null);
            }
        },

        updateValue(id, value) {
            this.$emit('update-value', id, value);
        },

        getOptionId(option) {
            return option.id ?? option.label;
        },

        getEffectClass(option) {
            if (this.isSelected(option)) {
                return option.effect !== 'fail'
                    ? 'btn btn-primary'
                    : 'btn btn-danger';
            }

            return 'btn btn-secondary bg-white';
        },

        getCheckColor(option) {
            return this.isSelected(option) ? 'white' : 'secondary';
        },

        handleRadioChange(new_id) {
            if (this?.selected?.includes(new_id)) {
                this.selected = [];
            } else {
                this.selected = [new_id];
            }
        },

        handleCheckBoxChange(new_id) {
            if (this?.selected?.includes(new_id)) {
                this.selected = this.selected.filter(id => id !== new_id) ?? [];
            } else {
                this.selected = [...this?.selected, new_id];
            }
        },

        isSelected(option) {
            return this?.selected?.includes(this.getOptionId(option)) ?? false;
        },
    },
}
</script>
